import {cs} from "./chain-services";
import {fragments} from "./fragments";
import {UseState} from "./use-state";
import {Invoke} from "./invoke";

export const GetLatestValue = ({value, condition=undefined, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => fragments(
        next(() => new Promise((resolve) => {
            state.onChange({resolve});
        })),

        state.value && (!condition || condition()) && (
            Invoke({
                action: () => {
                    state.value.resolve(value);
                    state.onChange(null);
                },
            })
        )
    ),
);
